import { render, staticRenderFns } from "./XIcon.vue?vue&type=template&id=b39c2c48"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b39c2c48')) {
      api.createRecord('b39c2c48', component.options)
    } else {
      api.reload('b39c2c48', component.options)
    }
    module.hot.accept("./XIcon.vue?vue&type=template&id=b39c2c48", function () {
      api.rerender('b39c2c48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/XIcon.vue"
export default component.exports